"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailInput = void 0;
/**
 * Renders an email box.
 */
const React = require("react");
const KeypadWrapper_1 = require("../../atoms/KeypadWrapper");
const Keypad_1 = require("../../atoms/Keypad");
const emailPadOptions_1 = require("../../atoms/Keypad/helpers/emailPadOptions");
const EmailInput = ({ value, placeholder = "john.smith@example.com", onInputChange, disabled, hideKeypad = false }) => {
    const input = (React.createElement("input", { "data-test": "input", type: "email", onChange: evt => onInputChange(evt.target.value), value: value || "", placeholder: placeholder, disabled: disabled }));
    return hideKeypad ? (input) : (React.createElement(KeypadWrapper_1.KeypadWrapper, { inputComponent: input, replace: emailPadOptions_1.emailPadOptions, keypadComponent: React.createElement(Keypad_1.EmailKeypad, null) }));
};
exports.EmailInput = EmailInput;
//# sourceMappingURL=index.js.map